import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'templatefilter'
  })
  export class TemplateSearchPipe implements PipeTransform {
    transform(items: any[], searchText: string) {
        return items ? items.filter(item => item.templateName?.search(new RegExp(searchText, 'i')) > -1) : [];
        }

  }